import { updateRemote } from '../atomic';
import ENTITIES from '..';

export function editObserver(store, data) {
  updateRemote(store, ENTITIES.OBSERVER, data);
}
